import React, { useEffect, useState } from 'react'

const typeableKeys = /^[a-zA-Z0-9\t\n ./<>?;:"'`!@#$%^&*()[\]{}_+=|\\-]+$/

export const useTypingWithinElement = (ref: React.RefObject<HTMLElement>, timeLimit = 1000) => {
  const [text, setText] = useState('')
  const [timer, setTimer] = useState(new Date())

  useEffect(() => {
    const listenTyping = (e: KeyboardEvent) => {
      if (!e.key) {
        return
      }
      const currentTime = new Date()
      if (e.key.length === 1 && typeableKeys.test(e.key)) {
        setText(t => {
          if (currentTime.getTime() - timer.getTime() > timeLimit) {
            return e.key
          }
          return t + e.key
        })
      } else if (e.key === 'Backspace') {
        setText('')
      }
      setTimer(currentTime)
    }
    const { current } = ref
    if (current) {
      current.addEventListener('keyup', listenTyping)
      return () => current.removeEventListener('keyup', listenTyping)
    }
  }, [ref, timer, timeLimit])

  return text
}
